import { render, staticRenderFns } from "./OmsMenu.vue?vue&type=template&id=5b4d8484&scoped=true"
import script from "./OmsMenu.vue?vue&type=script&lang=js"
export * from "./OmsMenu.vue?vue&type=script&lang=js"
import style0 from "./OmsMenu.vue?vue&type=style&index=0&id=5b4d8484&prod&lang=less&scoped=true"
import style1 from "./OmsMenu.vue?vue&type=style&index=1&id=5b4d8484&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d8484",
  null
  
)

export default component.exports